import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { styled } from '@mui/material';
import { colors } from 'constants/colors';

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: colors.default.green,
  width: '95%',
  '&:hover': {
    backgroundColor: colors.default.green,
  },
  [theme.breakpoints.down('md')]: {
    color: colors.default.infoText,
    width: '90%',
  },
}));
interface ModalSuccessReportProps {
  open: boolean;
  title: string;
  content: string;
  confirmText: string;
  onConfirm: () => any;
}

const ModalReportSuccess: React.FC<ModalSuccessReportProps> = ({
  open,
  title,
  content,
  confirmText,
  onConfirm,
}) => {
  return (
    <Modal open={open}>
      <Box
        sx={{
          backgroundColor: colors.default.info,
          border: 'unset',
          maxWidth: '400px',
          minWidth: '400px',
          height: '375px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          borderRadius: '30px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-evenly',
          alignItems: 'center',
        }}
      >
        <CheckCircleIcon
          color="secondary"
          sx={{
            border: `2px solid ${colors.default.info}`,
            borderRadius: '50%',
            position: 'absolute',
            top: 0,
            transform: 'translateY(-40%)',
            backgroundColor: colors.default.info,
            width: '70px',
            height: '70px',
          }}
        />
        <Typography
          variant="h6"
          component="h3"
          sx={{
            color: colors.default.info,
            fontFamily: 'Modak',
            fontSize: '44px',
            textAlign: 'center',
            textShadow: `0px 0px 10px ${colors.default.black}`,
            WebkitTextStroke: `2px ${colors.default.infoText}`,
            lineHeight: 1,
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{ textAlign: 'center', padding: '0 20px' }}
          component="p"
        >
          {content}
        </Typography>
        <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <StyledButton color="secondary" variant="text" onClick={onConfirm}>
            {confirmText}
          </StyledButton>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ModalReportSuccess;
